import logoWhite from "./assets/rio_logo_white.png";
import logoBlack from "./assets/rio_logo_black.png";

interface CompanyLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  clickable?: boolean;
  variant?: "auto" | "light" | "dark";
  showText?: boolean;
}

export function CompanyLogo({
  size = "md",
  className = "",
  clickable = false,
  variant = "auto",
}: CompanyLogoProps) {
  const sizeClasses = {
    sm: "h-7 sm:h-8 max-w-[120px]",
    md: "h-9 sm:h-10 max-w-[160px]",
    lg: "h-12 sm:h-14 max-w-[200px]",
    xl: "h-16 sm:h-20 max-w-[260px]",
  };

  const handleClick = () => {
    if (clickable) {
      window.location.hash = "dashboard";
    }
  };

  return (
    <div
      className={`flex items-center ${
        clickable ? "cursor-pointer hover:opacity-85 transition-opacity" : ""
      } ${className}`}
      onClick={handleClick}
    >
      {variant === "dark" ? (
        <img
          src={logoWhite}
          alt="RIO Project Management Logo"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      ) : variant === "light" ? (
        <img
          src={logoBlack}
          alt="RIO Project Management Logo"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      ) : (
        <>
          <img
            src={logoBlack}
            alt="RIO Project Management Logo"
            className={`${sizeClasses[size]} w-auto object-contain dark:hidden`}
          />
          <img
            src={logoWhite}
            alt="RIO Project Management Logo"
            className={`${sizeClasses[size]} w-auto object-contain hidden dark:block`}
          />
        </>
      )}
    </div>
  );
}
